import React from "react";
import { useNavigate } from "react-router-dom";
import { formatFirestoreDate } from "../../../utils/date_formatter";

const EventCard = ({ event }) => {
  const navigate = useNavigate();

  const posterUrl = event.poster?.verticalUrl || event.poster?.horizontalUrl;

  const handleClick = () => {
    navigate(`/events/${event.id}`);
  };

  return (
    <div
      onClick={handleClick}
      className="w-[180px] sm:w-[200px] md:w-[220px] h-auto sm:h-[350px] md:h-[389px] flex-shrink-0 cursor-pointer group transition-all duration-300 ease-out hover:scale-[1.04] hover:-translate-y-1.5"
    >
      {/* Card Container */}
      <div className="bg-transparent rounded-xl shadow-lg group-hover:shadow-xl transition-all duration-300 h-full flex flex-col">

        {/* Image Container */}
        <div className="relative w-full h-[200px] sm:h-[240px] md:h-[280px] flex-shrink-0 overflow-hidden rounded-xl transition-shadow duration-300 group-hover:shadow-[0_18px_40px_-12px_rgba(23,189,59,0.35)]">
          <img
            src={posterUrl}
            alt={event.name}
            className="w-full h-full object-cover"
          />

          {/* Hover overlay: gradient + Book Now reveal */}
          <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/25 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end justify-center pb-4 pointer-events-none">
            <span className="translate-y-4 opacity-0 group-hover:translate-y-0 group-hover:opacity-100 transition-all duration-300 delay-75 bg-[#17BD3B] text-white text-[12px] font-semibold px-4 py-2 rounded-lg flex items-center gap-1.5 shadow-lg shadow-[#17BD3B]/30">
              Book Now
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                <path d="M5 12h14M12 5l7 7-7 7" />
              </svg>
            </span>
          </div>
        </div>

        {/* Content Area - EXACT DESIGN MATCH */}
        <div className="mt-3 flex flex-col flex-1 min-h-0">
          {/* Event Title - White, Bold, 2 lines max */}
          <h2 className="text-white text-[14px] leading-[17px] font-medium mb-2 transition-colors duration-300 group-hover:text-[#17BD3B]" style={{
            fontFamily: 'Poppins',
            fontWeight: 500,
            display: '-webkit-box',
            WebkitLineClamp: 2,
            WebkitBoxOrient: 'vertical',
            overflow: 'hidden',
            minHeight: '34px'
          }}>
            {event.name}
          </h2>

          {/* Date - Gray, on its own line */}
          <div className="text-[12px] leading-[14px] font-normal mb-1" style={{
            color: '#B3B3B3',
            fontFamily: 'Poppins',
            fontWeight: 400
          }}>
            {formatFirestoreDate(event.startTime)}
          </div>

          {/* Venue - Gray, below date */}
          <div className="text-[12px] leading-[14px] font-normal" style={{
            color: '#B3B3B3',
            fontFamily: 'Poppins',
            fontWeight: 400
          }}>
            {event.eventLocation?.locationText || 'Location TBA'}
          </div>
        </div>
      </div>
    </div>
  );
};

export default EventCard;
